import { Grid } from '@mui/material';

import AppLink from '@/components/AppLink';
import useOnScreen from '@/hooks/useOnScreen';
import { BasetenPageEnum } from '@/routes';

import { ModelCard } from '../../styled';
import { GridCardWrapperProps } from './types';

function GridCardWrapper<TPage extends BasetenPageEnum>({
  linkParams,
  children,
  alwaysVisible = false,
  containerSx = {},
}: GridCardWrapperProps<TPage>) {
  const [ref, isVisible] = useOnScreen(
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    },
    alwaysVisible,
  );

  function getContent() {
    if (!isVisible) return null;

    return children;
  }

  return (
    <Grid ref={ref} item xs={12} sm={12} md={6} lg={4}>
      <AppLink {...linkParams} underline="none" sx={{ '&:hover': { textDecoration: 'none' } }}>
        <ModelCard sx={containerSx}>{getContent()}</ModelCard>
      </AppLink>
    </Grid>
  );
}

export default GridCardWrapper;
